module.exports = __webpack_public_path__ + "img/delete.884cc27e.svg";